module.exports = __webpack_public_path__ + "static/media/Asset 5.2@3x.088087c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 5.2@3x.png
// module id = 2393
// module chunks = 0